import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const certifications = [
    {
      id: 1,
      name: "ISO 27001",
      description: "Information Security Management",
      icon: "Shield",
      verified: true
    },
    {
      id: 2,
      name: "HIPAA Compliant",
      description: "Healthcare Data Protection",
      icon: "Lock",
      verified: true
    },
    {
      id: 3,
      name: "SOC 2 Type II",
      description: "Security & Availability Controls",
      icon: "CheckCircle",
      verified: true
    },
    {
      id: 4,
      name: "GDPR Ready",
      description: "Data Privacy Compliance",
      icon: "FileCheck",
      verified: true
    }
  ];

  return (
    <section className="bg-muted/30 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl font-semibold text-foreground mb-3">
            Enterprise-Grade Security & Compliance
          </h2>
          <p className="text-muted-foreground">
            Your privacy and data security are our top priorities
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {certifications?.map((cert) => (
            <div
              key={cert?.id}
              className="bg-card rounded-lg border border-border p-6 hover:shadow-md transition-shadow duration-200"
            >
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 rounded-lg p-3 flex-shrink-0">
                  <Icon name={cert?.icon} size={24} className="text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold text-foreground text-sm">
                      {cert?.name}
                    </h3>
                    {cert?.verified && (
                      <Icon name="BadgeCheck" size={16} className="text-success flex-shrink-0" />
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground">
                    {cert?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-muted-foreground">
            All data encrypted in transit and at rest • Regular security audits • 24/7 monitoring
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;